import { useEffect } from 'react';
import Stack from '@mui/material/Stack';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { DrawSVGPlugin } from '../vendor/gsap/DrawSVGPlugin';

import { KmxContainer } from '../../../components/KmxContainer';
import { step1Transition, step2Transition, step3Transition } from '../utils/animations';
import StepOne from './steps/StepOne';
import StepTwo from './steps/StepTwo';
import StepThree from './steps/StepThree';

const Steps = () => {
    useEffect(() => {
        gsap.registerPlugin(ScrollTrigger, DrawSVGPlugin);
        registerAnimations();
    }, []);

    const registerAnimations = () => {
        step1Transition();
        step2Transition();
        step3Transition();
    };

    return (
        <KmxContainer id="buying-online-steps-container" maxWidth="xl" sx={{ pb: { xs: 10, sm: 0 } }}>
            <Stack spacing={{ xs: 10, sm: 15 }} useFlexGap>
                <StepOne />
                <StepTwo />
                <StepThree />
            </Stack>
        </KmxContainer>
    );
};

export default Steps;
